import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import { ViewMode, type EpochState } from './state';
import { SignalOverflow } from '@/modules/epoch/types';

export const epochStore = {
  namespaced: true,
  state: {
    fullNight: {
      isLoading: false
    },
    signals: {},
    overlappedRespiratoryEvents: [],
    epochData: {
      isLoading: false,
      sets: []
    },
    graph: {
      zoom: {},
      overflowVisible: {},
      polarityInversion: {}
    },
    dialog: {
      visibility: false
    },
    events: {
      isLoading: false
    },
    eventActions: {},
    signalEvents: {},
    signalEventMapping: {
      Sleep_Stages: ['Unstaged', 'Wake', 'REM', 'N1', 'N2', 'N3'],
      EEG_frontal_R: ['Arousal EEG_frontal_R', 'Artifact EEG_frontal_R'],
      EEG_frontal_L: ['Arousal EEG_frontal_L', 'Artifact EEG_frontal_L'],
      EOG_R: ['Artifact EOG_R'],
      EOG_L: ['Artifact EOG_L'],
      EMG_mass_R: ['Bruxism_Mix_R', 'Bruxism_Phasic_R', 'Bruxism_Tonic_R', 'Artifact EMG_mass_R'],
      EMG_mass_L: ['Bruxism_Mix_L', 'Bruxism_Phasic_L', 'Bruxism_Tonic_L', 'Artifact EMG_mass_L'],
      ECG: [
        'Atrial Fibrillation',
        'PAC',
        'PVC',
        'AV_Block',
        'Pacemaker Rhythm',
        'Other Arrhythmia',
        'Asystole',
        'Narrow Complex Tachycardia',
        'Wide Complex Tachycardia',
        'Artifact ECG'
      ],
      Heart_rate: ['Sinus Tachycardia', 'Sinus Bradycardia', 'Artifact Heart_rate'],
      Resp_effort: ['Cheyne-Stokes Breathing', 'Artifact Resp_effort'],
      Resp_flow: [
        'Apnea Central Resp_flow',
        'Apnea Obstructive Resp_flow',
        'Apnea Mixed Resp_flow',
        'Hypopnea Central Resp_flow',
        'Hypopnea Obstructive Resp_flow',
        'RERA Resp_flow',
        'Artifact Resp_flow'
      ],
      SpO2: ['Desaturation', 'Artifact SpO2'],
      EMG_leg: ['Leg Movement', 'Periodic Leg Movement', 'Artifact EMG_leg'],
      Position: ['Artifact Position'],
      Activity: ['Artifact Activity'],
      Sound_SPL: ['Snoring', 'Artifact Sound_SPL'],
      Nasal_pressure: [
        'Apnea Central',
        'Apnea Obstructive',
        'Apnea Mixed',
        'Hypopnea Central',
        'Hypopnea Obstructive',
        'RERA',
        'Artifact Nasal_pressure'
      ]
    },
    settings: {
      signalsList: [],
      selectedPresetId: 1,
      presets: [],
      signalOverflow: SignalOverflow.None,
      band: true,
      notch: true,
      hypnogramFullNightSignals: [],
      viewMode: ViewMode.Single,
      dualTimeBase: {
        topWindowSize: 30,
        bottomWindowSize: 300,
        singleHypnogram: false
      },
      artifactColor: '#FF9999',
      shortcutKeys: []
    },
    initialAutoDefaults: {},
    granularOffsetSec: 0,
    pendingGranularOffsetSec: 0
  } as EpochState,
  actions,
  getters,
  mutations
};
